'use client';

import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

import { getProductInventoryPairs } from '../api';

type UseQueryInventoryPairsOptions = {
    storesku: { store: string; sku: string }[];
    options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>;
};

export const useQueryInventoryPairs = ({ storesku, options = {} }: UseQueryInventoryPairsOptions) => {
    const queryKey = ['inventory-pairs', storesku];

    return useQuery({
        queryKey,
        queryFn: () => getProductInventoryPairs(storesku),
        // staleTime – keep cache 1 hour - data is considered fresh for 1 hour,
        // and during this period, reusing the cache will not fetch new data.
        staleTime: 60 * 60 * 1000,
        ...options,
    });
};
